{
    "tracks": {
        "track_types": [
            {
                "label": "Main Line",
                "value": "MAIN LINE"
            },
            {
                "label": "Loop Line",
                "value": "LOOP LINE"
            },
            {
                "label": "Siding",
                "value": "SIDING"
            }
        ],
        "track_directions": [
            {
                "label": "Left to Right",
                "value": "left-to-right"
            },
            {
                "label": "Right to Left",
                "value": "right-to-left"
            },
            {
                "label": "Bi-Directional",
                "value": "bidirectional"
            }
        ],
        "track_section_types": [
            {
                "label": "Left Block Section",
                "value": "LEFT_BLOCK_SECTION"
            },
            {
                "label": "Station Section",
                "value": "STATION_SECTION"
            },
            {
                "label": "Right Block Section",
                "value": "RIGHT_BLOCK_SECTION"
            }
        ]
    },
    "structures": {
        "structure_types": [
            {
                "label": "Abs Hut",
                "value": "ABS HUT",
                "description": "Automatic Block Signalling hut"
            },
            {
                "label": "Bridge",
                "value": "BRIDGE",
                "description": "Bridge structure"
            },
            {
                "label": "Building",
                "value": "BUILDING",
                "description": "Building structure"
            },
            {
                "label": "Compass",
                "value": "COMPASS",
                "description": "Compass"
            },
            {
                "label": "Fob",
                "value": "FOB",
                "description": "Foot Over Bridge"
            },
            {
                "label": "Gate Lodge",
                "value": "GATE LODGE",
                "description": "Gate lodge"
            },
            {
                "label": "Goomty",
                "value": "GOOMTY",
                "description": "Goomty structure"
            },
            {
                "label": "Platform",
                "value": "PLATFORM",
                "description": "Railway platform"
            },
            {
                "label": "Railway Boundary",
                "value": "RAILWAY BOUNDARY",
                "description": "Railway land boundary traced from the drawing"
            },
            {
                "label": "Rub",
                "value": "RUB",
                "description": "Road Under Bridge structure"
            },
            {
                "label": "Station Building",
                "value": "STATION BUILDING",
                "description": "Auto-generated type for STATION_BUILDING"
            },
            {
                "label": "Station Building",
                "value": "STATION_BUILDING",
                "description": "Auto-generated type for STATION_BUILDING"
            },
            {
                "label": "Subway",
                "value": "SUBWAY",
                "description": "Subway structure"
            },
            {
                "label": "Trolley Path",
                "value": "TROLLEY PATH",
                "description": "Trolley path structure"
            }
        ]
    },
    "turnouts": {
        "turnout_types": [
            {
                "label": "Single Ended Turnout",
                "value": "Single ended turnout"
            },
            {
                "label": "Double Ended Turnout",
                "value": "Double ended turnout"
            }
        ]
    },
    "trap_points": {
        "trap_point_types": [
            {
                "label": "Single Ended Trap Point",
                "value": "Single ended trap point"
            },
            {
                "label": "Double Ended Trap Point",
                "value": "Double ended trap point"
            }
        ],
        "trap_point_directions": [
            {
                "label": "Up-left",
                "value": "up_left"
            },
            {
                "label": "Up-right",
                "value": "up_right"
            },
            {
                "label": "Bottom-left",
                "value": "down_left"
            },
            {
                "label": "Bottom-right",
                "value": "down_right"
            }
        ]
    },
    "gates": {
        "lc_classes": [
            {
                "label": "A Class",
                "value": "A"
            },
            {
                "label": "B Class",
                "value": "B"
            },
            {
                "label": "C Class",
                "value": "C"
            },
            {
                "label": "Special Class (SPL)",
                "value": "SPL"
            }
        ],
        "lc_manning_types": [
            {
                "label": "Manned",
                "value": "MANNED"
            },
            {
                "label": "Unmanned",
                "value": "UNMANNED"
            }
        ]
    },
    "dead_ends": {
        "dead_end_types": [
            {
                "label": "BS Dead End",
                "value": "BS DEAD END"
            },
            {
                "label": "Long Dead End",
                "value": "LONG DEAD END"
            },
            {
                "label": "Shed Dead End",
                "value": "SHED DEAD END"
            },
            {
                "label": "Sand Dead End",
                "value": "SAND DEAD END"
            }
        ]
    },
    "gradients": {
        "gradient_types": [
            {
                "label": "Raise",
                "value": "RAISE"
            },
            {
                "label": "Level",
                "value": "LEVEL"
            },
            {
                "label": "Fall",
                "value": "FALL"
            }
        ]
    },
    "clearances": {
        "clearance_types": [
            {
                "label": "Track to Track",
                "value": "TRACK_TRACK"
            },
            {
                "label": "Track to Structure",
                "value": "TRACK_STRUCTURE"
            },
            {
                "label": "Structure to Structure",
                "value": "STRUCTURE_STRUCTURE"
            },
            {
                "label": "Track to Boundary",
                "value": "TRACK_BOUNDARY"
            },
            {
                "label": "Structure Boundary",
                "value": "STRUCTURE_BOUNDARY"
            },
            {
                "label": "Boundary Boundary",
                "value": "BOUNDARY_BOUNDARY"
            }
        ]
    },
    "signals": {
        "visible_directions": [
            {
                "label": "Left to Right",
                "value": "left-to-right"
            },
            {
                "label": "Right to Left",
                "value": "right-to-left"
            },
            {
                "label": "Bidirectional",
                "value": "bidirectional"
            }
        ],
        "placements": [
            {
                "label": "Above",
                "value": "above"
            },
            {
                "label": "Below",
                "value": "below"
            },
            {
                "label": "Inside",
                "value": "inside"
            }
        ],
        "signal_aspects": [
            {
                "label": "Double Red",
                "value": "Double Red"
            },
            {
                "label": "Red",
                "value": "Red"
            },
            {
                "label": "Yellow",
                "value": "Yellow"
            },
            {
                "label": "Green",
                "value": "Green"
            },
            {
                "label": "Double Yellow",
                "value": "Double Yellow"
            },
            {
                "label": "Double Green",
                "value": "Double Green"
            }
        ],
        "indicator_directions": [
            {
                "label": "Upward",
                "value": "upward"
            },
            {
                "label": "Downward",
                "value": "downward"
            },
            {
                "label": "Vertical Up",
                "value": "vertical_up"
            },
            {
                "label": "Vertical Down",
                "value": "vertical_down"
            },
            {
                "label": "Backward Up",
                "value": "backward_up"
            },
            {
                "label": "Backward Down",
                "value": "backward_down"
            }
        ],
        "signal_types": [
            {
                "label": "Advance Starter Signal",
                "value": "b2fba4c0-899f-4352-bc48-aa6ecd789fa9",
                "description": "Authorizes a train to leave the station limits and enter the block section ahead.",
                "symbols": []
            },
            {
                "label": "Approaching Station Boundary",
                "value": "8f7467dd-3b0e-4e41-ab59-f1c6c856fae1",
                "description": "Indicates the approach towards station limits and alerts the driver to upcoming station-controlled signals.",
                "symbols": [
                    {
                        "name": "ASB Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "ASB",
                            "shape": "rectangle"
                        },
                        "description": "Symbol denoting Advance Starter Board function.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Border Signal",
                "value": "c09d0e09-bf85-4e4d-b26b-af9cfe4fb582",
                "description": "Marks the boundary between station limits and adjoining block section. Used to control train entry and exit at station boundaries.",
                "symbols": [
                    {
                        "name": "B Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "B",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting a Border function.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Bslb Signal",
                "value": "9c02534f-ba24-4359-b30d-a7b570ee83e0",
                "description": "Border Signal for Block Limit Board used to regulate train movement at block section limits.",
                "symbols": [
                    {
                        "name": "BSLB Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "BSLB",
                            "shape": "rectangle"
                        },
                        "description": "Symbol denoting Block Section Limit Board function.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Calling Home Signal",
                "value": "df062889-2aa0-4e1a-8c69-fcee3385e5e2",
                "description": "Authorizes a train to enter a station cautiously when the Home Signal is at danger, subject to operational rules.",
                "symbols": [
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Fully Automatic Signal",
                "value": "5bd91cc5-441b-4d15-8e89-894726ae1dfd",
                "description": "Operates automatically based on track occupancy without manual intervention.",
                "symbols": [
                    {
                        "name": "Fully Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "fully_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in fully automatic mode.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Gate Signal",
                "value": "6db63345-0617-4c85-8462-2c49b3cef01f",
                "description": "Controls train movement approaching a level crossing gate.",
                "symbols": [
                    {
                        "name": "G Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "G",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting Gate-controlled signal function.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Intermediate Block Border Signal",
                "value": "e5520059-32a4-4ccd-a0c3-a91bcdfe2dd5",
                "description": "Marks the boundary of an Intermediate Block Section and controls train entry into the next block.",
                "symbols": [
                    {
                        "name": "IB Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "IB",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting Intermediate Block function.",
                        "display_order": 1
                    },
                    {
                        "name": "B Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "B",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting a Border function.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Not a Valid Signal",
                "value": "01a08bc0-693b-72d4-9b57-a809941985be",
                "description": "Auto-generated type for Not a Valid Signal",
                "symbols": []
            },
            {
                "label": "Permissive Distant Cum Gate Signal",
                "value": "a4821736-0d76-43be-b0a7-ac893bf8d33d",
                "description": "Combination of Permissive Distant Signal and Gate Stop Signal.",
                "symbols": [
                    {
                        "name": "Permissive Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "yellow",
                            "label": "P",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting permissive working / cautionary movement.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Permissive Distant Signal",
                "value": "ad4ddeae-6bc4-49b8-9f4a-018b15466e23",
                "description": "Warns the driver about the aspect of the next Stop Signal and allows preparation for braking if required.",
                "symbols": [
                    {
                        "name": "Permissive Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "yellow",
                            "label": "P",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting permissive working / cautionary movement.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Permissive Inner Distant Cum Gate Signal",
                "value": "c02d6998-a214-46a9-b25f-c5f65f780789",
                "description": "Provides advance cautionary indication to the driver regarding the condition of the Gate Signal ahead. Combination of Permissive Inner Distant Signal and Gate Stop Signal.",
                "symbols": [
                    {
                        "name": "Permissive Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "yellow",
                            "label": "P",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting permissive working / cautionary movement.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Permissive Inner Distant Signal",
                "value": "4c61c187-0eb2-47ef-a346-4c48ce44b584",
                "description": "Provides advance cautionary indication to the driver regarding the condition of the Home Signal ahead.",
                "symbols": [
                    {
                        "name": "Permissive Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "yellow",
                            "label": "P",
                            "shape": "circle"
                        },
                        "description": "Symbol denoting permissive working / cautionary movement.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Semi Automatic Advance Starter Signal",
                "value": "010e9a4c-c092-4935-ba93-f034cc5aae34",
                "description": "Semi-automatic signal authorizing trains to leave station limits and enter the block section.",
                "symbols": [
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Semi Automatic Calling Home Signal",
                "value": "72ad9bbd-411e-4c9a-92cb-114dc8fb9383",
                "description": "A semi-automatic Calling Home Signal that can operate automatically or under station master control.",
                "symbols": [
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 1
                    },
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Semi Automatic Gate Cum Advance Starter Signal",
                "value": "4172f7b4-7691-4733-8ba1-e02a70aa6e72",
                "description": "Combined Gate and Advance Starter Signal operating in semi-automatic mode.",
                "symbols": [
                    {
                        "name": "AG Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "white",
                            "label": "AG",
                            "shape": "circle",
                            "context": "gate"
                        },
                        "description": "Marker indicating a Gate-associated signal (semi-automatic gate working).",
                        "display_order": 1
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Semi Automatic Gate Cum Calling Home Signal",
                "value": "312f8042-14e2-487a-a968-f1cd8f1bf4ea",
                "description": "Combined Gate and Calling Home Signal operating in semi-automatic mode.",
                "symbols": [
                    {
                        "name": "AG Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "white",
                            "label": "AG",
                            "shape": "circle",
                            "context": "gate"
                        },
                        "description": "Marker indicating a Gate-associated signal (semi-automatic gate working).",
                        "display_order": 1
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 2
                    },
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 3
                    }
                ]
            },
            {
                "label": "Semi Automatic Gate Cum Shunt Calling Home Signal",
                "value": "c838ca2e-d816-4e26-b877-2287b905b368",
                "description": "Combined Gate, Shunt and Calling Home Signal operating in semi-automatic mode.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    },
                    {
                        "name": "AG Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "white",
                            "label": "AG",
                            "shape": "circle",
                            "context": "gate"
                        },
                        "description": "Marker indicating a Gate-associated signal (semi-automatic gate working).",
                        "display_order": 2
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 3
                    },
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 4
                    }
                ]
            },
            {
                "label": "Semi Automatic Gate Cum Shunt Starter Signal",
                "value": "b1f80f0c-f257-44c5-ac8c-3d80a58cef1d",
                "description": "Combined Gate and Shunt Starter Signal operating in semi-automatic mode.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    },
                    {
                        "name": "AG Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "white",
                            "label": "AG",
                            "shape": "circle",
                            "context": "gate"
                        },
                        "description": "Marker indicating a Gate-associated signal (semi-automatic gate working).",
                        "display_order": 2
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 3
                    }
                ]
            },
            {
                "label": "Semi Automatic Gate Cum Starter Signal",
                "value": "98590704-33c6-4e60-9a30-5d6e43d3f028",
                "description": "Combined Gate and Starter Signal operating in semi-automatic mode.",
                "symbols": [
                    {
                        "name": "AG Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "white",
                            "label": "AG",
                            "shape": "circle",
                            "context": "gate"
                        },
                        "description": "Marker indicating a Gate-associated signal (semi-automatic gate working).",
                        "display_order": 1
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Semi Automatic Shunt Calling Home Signal",
                "value": "e60cba58-022a-430e-b902-7ffa2a596aee",
                "description": "Semi-automatic signal used for controlled shunting movement towards the Home Signal.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 2
                    },
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 3
                    }
                ]
            },
            {
                "label": "Semi Automatic Shunt Starter Signal",
                "value": "b61e0c2d-606d-4602-91ad-6ced8cb1e86b",
                "description": "A semi-automatic signal controlling shunting departures.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    },
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Semi Automatic Starter Signal",
                "value": "6f64a16e-8fc6-4bc4-abb0-8dda866884b6",
                "description": "Semi-automatic signal authorizing departure from a station or platform.",
                "symbols": [
                    {
                        "name": "Semi Automatic A Marker",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "mode": "semi_automatic",
                            "type": "marker",
                            "color": "white",
                            "label": "A",
                            "shape": "circle"
                        },
                        "description": "Marker indicating the signal operates in semi-automatic mode.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Shunt Calling Home Signal",
                "value": "0dd7ccd9-5af7-4a3e-9ca3-9073193d3fff",
                "description": "Permits shunting movement towards the Home Signal under restricted conditions.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    },
                    {
                        "name": "Calling On Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "C",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting Calling-On (subsidiary) movement authority.",
                        "display_order": 2
                    }
                ]
            },
            {
                "label": "Shunt Signal",
                "value": "3e58c615-64cf-4de9-8c5c-0c0789e373a7",
                "description": "Controls shunting movements within station limits or yards.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Shunt Starter Signal",
                "value": "46db95df-ec68-44bc-b830-bf621540860e",
                "description": "Authorizes shunting movement from sidings or yards towards designated tracks.",
                "symbols": [
                    {
                        "name": "Shunt Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "white",
                            "label": "SH",
                            "shape": "disc"
                        },
                        "description": "Symbol denoting shunt movement authority.",
                        "display_order": 1
                    }
                ]
            },
            {
                "label": "Standard Signal",
                "value": "01a08bc0-6936-726c-94e1-92e1326cc6c3",
                "description": "Auto-generated type for Standard Signal",
                "symbols": []
            },
            {
                "label": "Starter Signal",
                "value": "9daebc4d-f5a4-400e-b1c7-a645a4818983",
                "description": "Authorizes a train to depart from a station or platform and proceed onto the next section.",
                "symbols": []
            },
            {
                "label": "Stop Signal",
                "value": "57de2133-9cbf-4a97-864d-2fa2d1d54a0a",
                "description": "Commands a train to stop unless a proceed aspect is displayed.",
                "symbols": [
                    {
                        "name": "Stop Symbol",
                        "category": "SIGNAL SYMBOLS",
                        "representation": {
                            "type": "symbol",
                            "color": "red",
                            "label": "STOP",
                            "shape": "rectangle"
                        },
                        "description": "Symbol denoting a stop aspect / stop signal function.",
                        "display_order": 1
                    }
                ]
            }
        ]
    },
    "track_circuits": {
        "track_circuit_types": [
            {
                "label": "Double Axle Counter",
                "value": "97e9d30d-870b-499a-9309-2dea4263659a",
                "description": "Axle-counter based section detection using paired counting heads.",
                "symbols": [
                    {
                        "name": "Double Axle Counter Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "triangle",
                            "pattern": "double_axle_counter"
                        },
                        "description": "Marker representing a Double Axle Counter.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Double Track Circuit",
                "value": "f952bd6f-bb8f-4017-8965-026fe8af70b8",
                "description": "Track circuit covering two rail sections detected together.",
                "symbols": [
                    {
                        "name": "Double Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "line",
                            "pattern": "double"
                        },
                        "description": "Marker representing a Double Track Circuit.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Il Shaped Bottom Left Track Circuit",
                "value": "cafdd112-67a9-48bb-b231-700af28fab9c",
                "description": "Track circuit with an IL-shaped layout, oriented bottom-left.",
                "symbols": [
                    {
                        "name": "IL Shaped Bottom Left Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "IL",
                            "orientation": "bottom_left"
                        },
                        "description": "Marker for an IL-shaped track circuit, oriented bottom-left.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Il Shaped Bottom Right Track Circuit",
                "value": "ea883666-c5b9-4abd-ab20-9cac641cdbf1",
                "description": "Track circuit with an IL-shaped layout, oriented bottom-right.",
                "symbols": [
                    {
                        "name": "IL Shaped Bottom Right Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "IL",
                            "orientation": "bottom_right"
                        },
                        "description": "Marker for an IL-shaped track circuit, oriented bottom-right.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Il Shaped Top Left Track Circuit",
                "value": "55732e5c-02cc-4e99-9f27-018597b345f5",
                "description": "Track circuit with an IL-shaped layout, oriented top-left.",
                "symbols": [
                    {
                        "name": "IL Shaped Top Left Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "IL",
                            "orientation": "top_left"
                        },
                        "description": "Marker for an IL-shaped track circuit, oriented top-left.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Il Shaped Top Right Track Circuit",
                "value": "8ecb1ea1-d277-4599-b8b1-2c8ab7520a3c",
                "description": "Track circuit with an IL-shaped layout, oriented top-right.",
                "symbols": [
                    {
                        "name": "IL Shaped Top Right Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "IL",
                            "orientation": "top_right"
                        },
                        "description": "Marker for an IL-shaped track circuit, oriented top-right.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "L Shaped Bottom Left Track Circuit",
                "value": "84dd7e9d-04ae-48e7-bd87-0b2ae4fc8414",
                "description": "Track circuit with an L-shaped layout, oriented bottom-left.",
                "symbols": [
                    {
                        "name": "L Shaped Bottom Left Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "L",
                            "orientation": "bottom_left"
                        },
                        "description": "Marker for an L-shaped track circuit, oriented bottom-left.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "L Shaped Bottom Right Track Circuit",
                "value": "7e8cda76-8fc0-4d48-b52b-e70b5685a620",
                "description": "Track circuit with an L-shaped layout, oriented bottom-right.",
                "symbols": [
                    {
                        "name": "L Shaped Bottom Right Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "L",
                            "orientation": "bottom_right"
                        },
                        "description": "Marker for an L-shaped track circuit, oriented bottom-right.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "L Shaped Top Left Track Circuit",
                "value": "0243013a-28d5-403f-bb00-71ea75ff058d",
                "description": "Track circuit with an L-shaped layout, oriented top-left.",
                "symbols": [
                    {
                        "name": "L Shaped Top Left Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "L",
                            "orientation": "top_left"
                        },
                        "description": "Marker for an L-shaped track circuit, oriented top-left.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "L Shaped Top Right Track Circuit",
                "value": "a1b565f7-4bd8-429f-a9d8-73b030b8b77a",
                "description": "Track circuit with an L-shaped layout, oriented top-right.",
                "symbols": [
                    {
                        "name": "L Shaped Top Right Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "L",
                            "orientation": "top_right"
                        },
                        "description": "Marker for an L-shaped track circuit, oriented top-right.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Rail Joint",
                "value": "4c3e433f-f326-460b-a4d6-040f5782b325",
                "description": "Insulated/mechanical rail joint marking a track circuit boundary.",
                "symbols": [
                    {
                        "name": "Rail Joint Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "joint_line"
                        },
                        "description": "Marker representing a Rail Joint.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Single Axle Counter",
                "value": "eeb65a9b-7001-4118-ba5e-a13914384afb",
                "description": "Axle-counter based section detection using a single counting head.",
                "symbols": [
                    {
                        "name": "Single Axle Counter Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "triangle",
                            "pattern": "single_axle_counter"
                        },
                        "description": "Marker representing a Single Axle Counter.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Single Track Circuit",
                "value": "a93a2684-0a72-4739-949a-07165198c396",
                "description": "Track circuit covering a single rail section, detected as one continuous circuit.",
                "symbols": [
                    {
                        "name": "Single Track Circuit Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "line",
                            "pattern": "single"
                        },
                        "description": "Marker representing a Single Track Circuit.",
                        "display_order": null
                    }
                ]
            },
            {
                "label": "Single Track Single Axle Counter",
                "value": "01a0f3b7-f9e6-7311-86aa-3a2a13bc676a",
                "description": "Single track circuit paired with a single axle counter (DC track circuit and MSDAC stations).",
                "symbols": [
                    {
                        "name": "Single Track Single Axle Counter Marker",
                        "category": "TRACK CIRCUIT SYMBOLS",
                        "representation": {
                            "type": "marker",
                            "color": "black",
                            "shape": "line",
                            "pattern": "single_track_single_axle_counter"
                        },
                        "description": "Marker representing a Single Track Circuit paired with a Single Axle Counter (DC track circuit and MSDAC stations).",
                        "display_order": null
                    }
                ]
            }
        ]
    },
    "distance_pairs": {
        "asset_types": [
            {
                "label": "Center Track Distance",
                "value": "d8ace9ca-d7a1-4e67-b36a-12c53992ff2b",
                "code": "CENTER_TRACK_DISTANCE",
                "description": null
            },
            {
                "label": "Crank handle",
                "value": "b60a03af-ef1b-47ca-9c73-7e02ee2cf4c1",
                "code": "CRANK_HANDLE",
                "description": null
            },
            {
                "label": "CSR Value",
                "value": "21aae2c6-b237-4a1f-bd2f-f7b8901077b0",
                "code": "CSR_VALUE",
                "description": null
            },
            {
                "label": "Dead End",
                "value": "d04945bd-343f-4ba2-ac48-a90c4336c211",
                "code": "DEAD_END",
                "description": null
            },
            {
                "label": "Distance Pair",
                "value": "d6c4345f-a39e-483c-923e-d3bdf693c365",
                "code": "DISTANCE_PAIR",
                "description": null
            },
            {
                "label": "Gradient",
                "value": "70b1d39d-78c8-4859-a547-d19a28b3f031",
                "code": "GRADIENT",
                "description": null
            },
            {
                "label": "Level Crossing Gate",
                "value": "17aaa3ca-bcdf-4737-8a88-4391d980d201",
                "code": "GATE",
                "description": null
            },
            {
                "label": "Neutral Zone",
                "value": "01a0cdc1-41e4-71f9-b78a-69d30547c0e3",
                "code": "NEUTRAL_ZONE",
                "description": null
            },
            {
                "label": "Railway Boundary",
                "value": "7043e7d6-d544-4611-aea2-439cf8bee6e4",
                "code": "RAILWAY_BOUNDARY",
                "description": null
            },
            {
                "label": "Signal",
                "value": "7b6d79ca-1ded-4d75-b555-580c638b827e",
                "code": "SIGNAL",
                "description": null
            },
            {
                "label": "Structure",
                "value": "68d8b1fc-8aa3-45d9-8a88-cbbb02b36c83",
                "code": "STRUCTURE",
                "description": null
            },
            {
                "label": "Structure Structure Distance",
                "value": "e3730fca-9e39-46e6-8c11-466257dc6b17",
                "code": "STRUCTURE_STRUCTURE_DISTANCE",
                "description": null
            },
            {
                "label": "Switch Rail Joint",
                "value": "d4d006fc-d191-4209-bb5b-a0c84e0ec4bc",
                "code": "SRJ",
                "description": null
            },
            {
                "label": "Track",
                "value": "4c60c6fd-f1f0-43bb-a8a1-677d36e23cbd",
                "code": "TRACK",
                "description": null
            },
            {
                "label": "Track Circuit",
                "value": "e891d5ec-40cc-4d9f-b750-84141fbabeea",
                "code": "TRACK_CIRCUIT",
                "description": null
            },
            {
                "label": "Track Circuit Name",
                "value": "fe08f307-a73d-4c9c-9dd1-2db3ff0511f6",
                "code": "TRACK_CIRCUIT_NAME",
                "description": null
            },
            {
                "label": "Track Curvature",
                "value": "c1000000-0000-0000-0000-000000000019",
                "code": "CURVATURE",
                "description": "Track Curvature"
            },
            {
                "label": "Track Route Button",
                "value": "31fc3153-7e5a-4574-a173-40a66ecc3785",
                "code": "TRACK_ROUTE_BUTTON",
                "description": null
            },
            {
                "label": "Track Section",
                "value": "ece729c6-010c-40ff-a5b6-3a66745bfa35",
                "code": "TRACK_SECTION",
                "description": null
            },
            {
                "label": "Track Structure Distance",
                "value": "046a3aca-bcf2-48bb-9364-48840d94c177",
                "code": "TRACK_STRUCTURE_DISTANCE",
                "description": null
            },
            {
                "label": "Turning Point",
                "value": "8c9b96cf-2660-4081-9ed2-7c18a3525432",
                "code": "TURNING_POINT",
                "description": null
            },
            {
                "label": "Turnout",
                "value": "1eb2363d-34c4-447d-a888-8b3932d331e1",
                "code": "TURNOUT",
                "description": null
            }
        ]
    }
}